import type { DashboardState } from '../index';

const closeMenu = (state: DashboardState) => {
  state.menuOpened = false;
};

export { closeMenu };
